"use strict";

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledCard = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _spacing = require("../../system/spacing.style");

var _shadows = require("../../system/shadows.style");

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  ", "\n  list-style: none;\n  background: ", ";\n  ", ";\n  border-radius: ", ";\n  border-color: ", ";\n  border-width: ", ";\n  box-shadow: ", ";\n  margin: ", ";\n  ", "\n  ", "\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n    border: none;\n  "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n      border: ", " ", " ", ";\n    "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n      border-left: ", ";\n      border-right: ", ";\n      border-top: ", ";\n      border-bottom: ", ";\n    "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n      ", "\n    "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n        ", "\n        @media screen and (min-width: ", ") {\n          border-radius: 0;\n          border: none;\n          border-right: ", ";\n          border-bottom: ", ";\n          :nth-of-type(odd) {\n            border-left: ", ";\n          }\n          :nth-of-type(2) {\n            border-top-right-radius: ", ";\n            border-top: ", ";\n          }\n          :first-of-type {\n            border-top-left-radius: ", ";\n            border-top-right-radius: 0;\n            border-top: ", ";\n          }\n          :last-of-type {\n            border-bottom-right-radius: ", ";\n            border-bottom-left-radius: 0;\n            :nth-of-type(odd) {\n              border-bottom-left-radius: ", ";\n            }\n          }\n          :nth-last-child(2):nth-child(even) {\n            border-bottom-right-radius: ", ";\n          }\n          :nth-last-child(2):nth-child(odd) {\n            border-bottom-left-radius: ", ";\n          }\n        }\n      "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var borderCollapsed = function borderCollapsed(props) {
  var borderCollapse = props.borderCollapse,
      columns = props.columns,
      theme = props.theme;
  var _theme$card$border = theme.card.border,
      width = _theme$card$border.width,
      style = _theme$card$border.style,
      color = _theme$card$border.color,
      radius = _theme$card$border.radius;
  var verticalCollapse = "\n    border-radius: 0;\n    border-bottom: none;\n    :first-of-type {\n      border-radius: ".concat("".concat(radius, " ").concat(radius, " 0 0"), ";\n    }\n    :last-of-type {\n      border-radius: ", "0 0 ".concat(radius, " ").concat(radius), ";\n      border-bottom: ", "".concat(width, " ").concat(style, " ").concat(color), ";\n    }\n  ");

  if (borderCollapse) {
    if (columns === 2) {
      return (0, _styledComponents.css)(_templateObject(), verticalCollapse, function () {
        return theme.breakpoints && theme.breakpoints.sm;
      }, "".concat(width, " ").concat(style, " ").concat(color), "".concat(width, " ").concat(style, " ").concat(color), "".concat(width, " ").concat(style, " ").concat(color), radius, "".concat(width, " ").concat(style, " ").concat(color), radius, "".concat(width, " ").concat(style, " ").concat(color), radius, radius, radius, radius);
    }

    return (0, _styledComponents.css)(_templateObject2(), verticalCollapse);
  }

  return null;
};

var setBorder = function setBorder(props) {
  if (props.borderLeft || props.borderRight || props.borderTop || props.borderBottom) {
    return (0, _styledComponents.css)(_templateObject3(), props.borderLeft && "".concat(props.theme.card.border.width, " ").concat(props.theme.card.border.style, " ").concat(props.theme.card.border.color), props.borderRight && "".concat(props.theme.card.border.width, " ").concat(props.theme.card.border.style, " ").concat(props.theme.card.border.color), props.borderTop && "".concat(props.theme.card.border.width, " ").concat(props.theme.card.border.style, " ").concat(props.theme.card.border.color), props.borderBottom && "".concat(props.theme.card.border.width, " ").concat(props.theme.card.border.style, " ").concat(props.theme.card.border.color));
  }

  if (props.borderAll) {
    return (0, _styledComponents.css)(_templateObject4(), props.theme.card.border.width, props.theme.card.border.style, props.theme.card.border.color);
  }

  return (0, _styledComponents.css)(_templateObject5());
};

var StyledCard = _styledComponents.default.div(_templateObject6(), function (props) {
  return (0, _spacing.spacingStyle)(props.theme, null, props.inset);
}, function (props) {
  return props.backgroundColor || props.theme.card.background.color;
}, function (props) {
  return setBorder(props);
}, function (props) {
  return props.borderRadius ? props.theme.card.border.radius : '0';
}, function (props) {
  return props.borderColor;
}, function (props) {
  return props.borderWidth;
}, function (props) {
  return props.theme.card.boxShadow;
}, function (props) {
  return props.margin;
}, function (props) {
  return (0, _shadows.shadowStyle)(props.theme, props.shadow);
}, borderCollapsed);

exports.StyledCard = StyledCard;